import {
  Body as BodyDS,
  Box,
  MaterialUICore,
  tokens,
} from '@iclinic/design-system';

const { styled, Modal: ModalDS } = MaterialUICore;

export const Modal = styled(ModalDS)({});

export const ModalContainer = styled(Box)(({ theme }) => ({
  overflow: 'auto',
  height: '100%',
  background: 'linear-gradient(248.1deg, #0063CF 0%, #003F72 100%)',
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    display: 'block',
  },
}));

export const FlexContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',

  [theme.breakpoints.down('xs')]: {
    padding: tokens.spacing.sm,
  },
}));

export const CardContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: tokens.spacing.xxxl,
  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column',
  },
}));

export const Body = styled(BodyDS)({
  letterSpacing: '0.44px',
  marginBottom: tokens.spacing.md,
});

export const ShapeUp = styled('img')(({ theme }) => ({
  position: 'absolute',
  top: '30px',
  left: '30px',
  [theme.breakpoints.down('xs')]: {
    display: 'none',
  },
}));

export const ShapeDown = styled('img')(({ theme }) => ({
  position: 'absolute',
  bottom: '30px',
  right: '30px',
  [theme.breakpoints.down('xs')]: {
    display: 'none',
  },
}));
